export const getRouteParam = (props, param) => {
    const match = props.match || {}
    const params = match.params || {}
    return params[param]
  }